import { defineComponent as _defineComponent } from 'vue'
import FormContainer from "../shared/FormContainer.vue"
import { PropType } from "vue"
import { OnboardingFormValues } from "../shared/types"
import PersonalInfoForm, { PersonalInfoForm as PersonalInfoFormType } from "./PersonalInfoForm.vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalInfoFormContainer',
  props: {
  form: {
    type: Object as PropType<PersonalInfoFormType>,
    required: false,
  },
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  showAvatar: {
    type: Boolean,
    default: true,
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY,
      iconColor: THEMES.PERALTA_PRIMARY_RED,
    }),
    required: false,
  },
  submitBtnLabel: {
    type: String,
    default: "Continue",
  },
  isExistingEmail: {
    type: Boolean,
    default: false,
  },
  showPasswordInput: {
    type: Boolean,
    default: false,
  },
  fields: {
    type: Array as PropType<string[]>,
  },
  subtitle: {
    type: String,
    default: "",
  },
},
  emits: ["gotoNext", "change", "gotoPrev"],
  setup(__props, { emit }) {

const props = __props





const onChange = (value: OnboardingFormValues) => {
  emit("change", value)
}

const onSubmit = () => {
  emit("gotoNext")
}

return { __sfc: true,props, emit, onChange, onSubmit, FormContainer, PersonalInfoForm }
}

})